import { render, staticRenderFns } from "./tarifaRow.vue?vue&type=template&id=57ab0620&scoped=true"
import script from "./tarifaRow.vue?vue&type=script&lang=js"
export * from "./tarifaRow.vue?vue&type=script&lang=js"
import style0 from "./tarifaRow.vue?vue&type=style&index=0&id=57ab0620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ab0620",
  null
  
)

export default component.exports